import { configureStore } from '@reduxjs/toolkit';

import { environment } from '@paragon/environment-tools';
import { logInData } from '@paragon/login-tools';
import { materialLists } from '@paragon/material-lists';
import { notifications } from '@paragon/notification-tools';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

import { lumberOptions } from './lumberOptionsSlice';
import { materialSetPrototype } from './materialSetPrototypeSlice';
import { plateGrip } from './plateGripDesignValuesSlice';
import { plateOptions } from './plateOptionsSlice';

export const store = configureStore({
  reducer: {
    environment,
    logInData,
    materialLists,
    materialSetPrototype,
    notifications,
    spinnerMessages,
    theme,
    plateOptions,
    lumberOptions,
    plateGrip,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
